import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@material-ui/core';
import { Storage } from 'aws-amplify';

import { FormProvider, useForm } from 'react-hook-form';
import Utils from '@/common/utils/utils';
import { I18n } from '@aws-amplify/core';
import FormInput from '@/component/common/form/input';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import Constant from '@/common/constant/Constant';
import './UserProfile.css';
import CropImage from '@/component/common/form/crop-image';
import { editUserProfile, getUserAvatarUrl} from '@/service/userService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import GlobalPhoneInput from '../common/form/global-phone-input';
import { string } from 'yup';
import FormInputWithOnChange from '../common/form/input-with-onchange';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import { uploadFileToS3 } from '@/service/s3Service';
import { useSnackbar } from 'notistack';
import schema from '@/schema/UserProfileSchema';
import { yupResolver } from '@hookform/resolvers';



export default function UserProfileTab(props) {
    // common user state state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
	const inputFileRef = useRef(null);
	const [inputImage, setInputImage] = useState('');
	const [errorImage, setErrorImage] = useState(false);
	const [openCrop, setOpenCrop] = useState(false);
	const [imagePreview, setImagePreview] = useState(userDetail.avatar);
	const [croppedImage, setCroppedImage] = useState(null);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
	const methods = useForm({
        mode: 'all',
        resolver: yupResolver(schema),
        defaultValues: {
            lastName: userDetail?.lastName
                ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, userDetail?.lastName)
                : '',
            firstName: userDetail?.firstName
                ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, userDetail?.firstName)
                : '',
            email: userDetail?.mail ? userDetail?.mail : '',

        }
    });
	const { handleSubmit, getValues, setValue, register, errors, formState, reset} = methods;
	const { setIsLoading } = props;
    const { enqueueSnackbar } = useSnackbar();
    
    const handleSubmitEditUserDetail = async () => {
        // check error crop images
        const formData = getValues();
        if (errorImage) {
            return;
        }
        setIsLoading(true);

        let userForUpdate = {
            id: userDetail.id,
            userId: userDetail.mail,
            firstName: formData.firstName,
            lastName: formData.lastName,
            tel: formData.phoneNumber,
            image: userDetail.image
        };

        if (croppedImage && croppedImage.file) {
            let filePath = `user_avatar/${userDetail.mail}${new Date().getTime()}`;
            let fileUpload = {...croppedImage}
            fileUpload.key = filePath;

            let uploadAvatar = await uploadFileToS3(filePath, fileUpload);  
            if (!uploadAvatar) {
                setIsLoading(false);
                return;
            }
            userForUpdate.image = filePath;
        }

        const updateResult = await editUserProfile(props.api, userForUpdate);
        if(updateResult) {
            enqueueSnackbar(I18n.get('COMMSG047'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            reset(formData);
        }
        
        // let newUserDetail = { ...userDetail };
        // newUserDetail.avatar = await Storage.get(updateResult.image);
        // newUserDetail.image = updateResult.image;
        // newUserDetail.lastName = updateResult.lastName;
        // newUserDetail.firstName = updateResult.firstName;
        // newUserDetail.tel = updateResult.tel;
        // newUserDetail.workSpace = Utils.convertJSONDataToObject(updateResult.workSpace);
        // setUserDetail(newUserDetail);
        // props.setIsProfileHasChange(false);
        // setCroppedImage(null);
        // setIsLoading(false);

        // if(croppedImage) {
        //     // window.location.reload();
        // }

        window.location.reload();
        return
    };

    useEffect(() => {
        //chưa dùng phoneNumber nên tạm thời ẩn đi
        // register('phoneNumber');
        // setValue('phoneNumber', userDetail?.tel ? userDetail?.tel : '');

        let lastName = userDetail?.lastName
            ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, userDetail?.lastName)
            : '';
        let firstName = userDetail?.firstName
            ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, userDetail?.firstName)
            : '';
        setValue('email', userDetail?.mail ? userDetail?.mail : '');
        setValue('lastName', lastName);
        setValue('firstName', firstName);
    }, []);

    useEffect(() => {
        if (props.submitChangeUserProfileStatus) {
            handleSubmitEditUserDetail().then(res => {
                if (props.submitChangeUserProfileStatus === 1) {
                    props.setTabSelected('persionalSetting');
                } else {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.PERSONAL_MANAGEMENT,
                        panelId: props.panelId,
                        tabId: 'system_user_profile'
                    });
                }
                props.setSubmitChangeUserProfileStatus(0);
            });
        }
    }, [props.submitChangeUserProfileStatus]);

    const onFileChange = event => {
        let file = event.target.files[0];
        // check file input
        if (Utils.isEmptyObject(file)) {
            return;
        }
        props.setIsProfileHasChange(true)
        Utils.readFileAsArrayBuffer(file).then(reader => {
            let buffer = new Buffer(reader.result);
            let imgBase64 = buffer.toString('base64');

            setInputImage(`data:${file.type};base64,${imgBase64}`);
            setOpenCrop(true);
            event.target.value = '';
        });
    };

    return (
        <div className="userProfileTab scrollTab">
            <div className="settingFrame">
                <FormProvider {...methods}>
                    <div className="userProfileForm">
                        <div className="userProfileHeader">
                            <div className="userAvatar">
                                <img src={imagePreview} alt="" />
                                <div className="userAvatarInput">
                                    <input
                                        id="contained-button-file-user-profile"
                                        type="file"
                                        accept="image/*"
                                        className="updateFile"
                                        onChange={onFileChange}
                                        ref={inputFileRef}
                                    />
                                    <label>
                                        <Button
                                            onClick={() => inputFileRef.current.click()}
                                            variant="contained"
                                            component="span"
                                        >
                                            画像ファイルを選択
                                        </Button>
                                    </label>
                                    {errorImage && (
                                        <div className="imageError">{I18n.get('USER02MSG001')}</div>
                                    )}
                                </div>
                            </div>

                            <div className="form-list-header-control customHeaderbtn">
                                <Button
                                    className="btn-control btn-send  btn-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit(handleSubmitEditUserDetail)}
                                    disabled={!formState.isValid || (!formState.isDirty && !croppedImage)}
                                >
                                    反映
                                </Button>
                            </div>
                        </div>

                        <div className="userInfo">
                            <div className="userInfoName">
                                <div className="userInfoItem userInfoLastName">
                                    <div className="userInfoNameLabel">
                                        <span>姓</span>
                                        <span className="star-required">*</span>
                                    </div>
                                    <FormInputWithOnChange
                                        name="lastName"
                                        defaultValue={
                                            userDetail?.lastName
                                                ? Utils.getTextByLanguage(
                                                      Constant.LANGUAGE_TYPE.JP,
                                                      userDetail?.lastName
                                                  )
                                                : ''
                                        }
                                        onChange= {e => props.setIsProfileHasChange(true)}
                                        className="form-control form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        size="small"
                                        errorlist={errors}
                                    />
                                </div>
                                <div className="userInfoItem customItemMiddle userInfoFirstName">
                                    <div className="userInfoNameLabel">
                                        <span>名</span>
                                        <span className="star-required">*</span>
                                    </div>
                                    <FormInputWithOnChange
                                        name="firstName"
                                        defaultValue={
                                            userDetail?.firstName
                                                ? Utils.getTextByLanguage(
                                                      Constant.LANGUAGE_TYPE.JP,
                                                      userDetail?.firstName
                                                  )
                                                : ''
                                        }
                                        onChange= {e => props.setIsProfileHasChange(true)}
                                        className="form-control form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        size="small"
                                        errorlist={errors}
                                    />
                                </div>
                            </div>

                            <div className="userInfoItem">
                                <div className="userInfoNameLabel">
                                    <span>メールアドレス</span>
                                </div>
                                <div>
                                    <FormInput
                                        name="email"
                                        className="form-control form-control-wrapInput form-control-hg40"
                                        defaultValue={userDetail.mail}
                                        variant="outlined"
                                        size="small"
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="notiDestinationSettings">
                        <h2 className="title">通知先の設定</h2>
                        <div className="notiDestinationSettingsForm">
                            <div className="userInfoItem">
                            <div className="userInfoNameLabel"><span>メールへの通知</span></div>
                                <div className="userInfoItem-form">
                                    <FormInput
                                        name="notiEmailAddress"
                                        className="form-control form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        size="small"
                                    />
                                </div>
                            </div>
                            <div className="userInfoItem">
                                <span>ショートメッセージへの通知</span>
                                <div className="userInfoItem-form">
                                    <PhoneInput
                                        country={'jp'}
                                        value={numberPhone}
                                        onChange={setNumberPhone}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        inputProps={{
                                            name: 'phoneNumber',
                                            className: 'form-control',
                                            variant: 'outlined',
                                            size: 'small'
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="userInfoItem">
                                <span>ショートメッセージへの通知</span>
                                <div className="userInfoItem-form">
                                    <GlobalPhoneInput
                                        country={'jp'}
                                        value={defaultNumberPhone}
                                        onChange={e => {
                                            setValue('phoneNumber',e)
                                            props.setIsProfileHasChange(true)
                                        }}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        inputProps={{
                                            name: 'phoneNumber',
                                            className: 'form-control',
                                            variant: 'outlined',
                                            size: 'small',
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="userInfoItem">
                            <div className="userInfoNameLabel"><span>Slackへの通知</span></div>
                                <div className="userInfoItem-form">
                                    <FormInput
                                        name="slackAddress"
                                        className="form-control form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        size="small"
                                    />
                                </div>
                            </div>
                            <div className="userInfoItem">
                            <div className="userInfoNameLabel"><span>Google Chatへの通知</span></div>
                                <div className="userInfoItem-form">
                                    <FormInput
                                        name="googleAddress"
                                        className="form-control form-control-wrapInput form-control-hg40"
                                        variant="outlined"
                                        size="small"
                                    />
                                </div>
                            </div>
                        </div>
                    </div> */}
                </FormProvider>
            </div>
            {/* crop image */}
            <CropImage
                openCrop={openCrop}
                setOpenCrop={setOpenCrop}
                aspect={1}
                cropShape={'round'}
                inputImage={inputImage}
                setInputImage={setInputImage}
                setImagePreview={setImagePreview}
                setCroppedImage={setCroppedImage}
                setErrorImage={setErrorImage}
            />
        </div>
    );
}
